import { render } from "./ReferenceInfoList.vue?vue&type=template&id=b713b3b0&scoped=true"
import script from "./ReferenceInfoList.vue?vue&type=script&lang=js"
export * from "./ReferenceInfoList.vue?vue&type=script&lang=js"

import "./ReferenceInfoList.vue?vue&type=style&index=0&id=b713b3b0&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b713b3b0"]])

export default __exports__